import React from "react";

const SvgRemoveIcon = props => <svg width={32} height={32} fill="none" {...props}><path stroke="#CA3838" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={2} strokeWidth={2} d="M13 25v4h6v-4M19 13V9h-6v4M24 15L8 23M8 15l16 8M13 5V3h6v2" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/removeIcon_b68046.svg";
export { SvgRemoveIcon as ReactComponent };